/*
 * ST 2026-10-20 footer redesign (Wrike 4574066732). Loaded deferred by sections/st-footer.liquid.
 * - Link columns are <details>: below 900 px accordions (one open at a time, D2); from 900 px always open,
 *   the summary does nothing. The inline script in the section closes them on mobile before first paint.
 * - Country selector (<details>): closes on outside click and on Escape.
 * - Newsletter: the Klaviyo footer embed renders as Klaviyo builds it (D2: field + button stacked only when the
 *   placeholder would not fit, see fitRow). Round 7: "5%" in its texts gets a
 *   non-breaking space ("5 %", house style). Klaviyo renders the form late and may re-render it, so a
 *   MutationObserver watches the newsletter block. Text nodes only; the form, its texts and its logic stay in Klaviyo.
 */
(function () {
  "use strict";

  var MQ = window.matchMedia("(min-width: 900px)");

  function init(root) {
    if (!root || root.dataset.stFtReady) return;
    root.dataset.stFtReady = "1";

    var accs = Array.prototype.slice.call(
      root.querySelectorAll("[data-st-ft-acc]"),
    );

    function sync() {
      accs.forEach(function (d) {
        if (MQ.matches) d.setAttribute("open", "");
        else d.removeAttribute("open");
      });
    }

    accs.forEach(function (d) {
      var summary = d.querySelector("summary");
      summary.addEventListener("click", function (e) {
        if (MQ.matches) e.preventDefault();
      });
      d.addEventListener("toggle", function () {
        if (MQ.matches || !d.open) return;
        accs.forEach(function (other) {
          if (other !== d) other.removeAttribute("open");
        });
      });
    });

    if (MQ.addEventListener) MQ.addEventListener("change", sync);
    sync();
    watchNewsletter(root);

    var country = root.querySelector("[data-st-ft-country]");
    if (country) {
      document.addEventListener("click", function (e) {
        if (country.open && !country.contains(e.target))
          country.removeAttribute("open");
      });
      country.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && country.open) {
          country.removeAttribute("open");
          country.querySelector("summary").focus();
        }
      });
    }
  }

  var PCT = /(\d)[ ]?%/g;

  function fixPercent(node) {
    var walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
    var text;
    while ((text = walker.nextNode())) {
      if (PCT.test(text.nodeValue)) {
        text.nodeValue = text.nodeValue.replace(PCT, "$1\u00a0%");
      }
      PCT.lastIndex = 0;
    }
  }

  // D2: field and button share one row. If the field would cut Klaviyo's placeholder (long button text, narrow
  // phone, long es/it/fr placeholder), stack both (class --stack, CSS). Measured, so it adapts to every market.
  var canvas;

  function fitRow(news) {
    var input = Array.prototype.find.call(
      news.querySelectorAll('input[type="email"]'),
      function (el) {
        return el.offsetWidth > 0;
      },
    );
    if (!input || !input.placeholder) return;
    news.classList.remove("st-ft__klaviyo--stack");
    var cs = getComputedStyle(input);
    canvas = canvas || document.createElement("canvas");
    var ctx = canvas.getContext("2d");
    ctx.font = cs.fontSize + " " + cs.fontFamily;
    var need =
      ctx.measureText(input.placeholder).width +
      parseFloat(cs.paddingLeft) +
      parseFloat(cs.paddingRight) +
      2;
    if (need > input.clientWidth) news.classList.add("st-ft__klaviyo--stack");
  }

  function watchNewsletter(root) {
    var news = root.querySelector(".st-ft__klaviyo");
    if (!news || !window.MutationObserver) return;
    var queued = false;
    function update() {
      queued = false;
      fixPercent(news);
      fitRow(news);
    }
    function queue() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(update);
    }
    update();
    // The replacement contains no plain space before "%", so the observer's own edits do not match again;
    // the class toggle is an attribute change on the observed node itself, which is not observed.
    new MutationObserver(queue).observe(news, {
      childList: true,
      subtree: true,
      characterData: true,
    });
    window.addEventListener("resize", queue);
    // Measured with the fallback font before Inter has loaded → measure again once fonts are ready.
    if (document.fonts && document.fonts.ready)
      document.fonts.ready.then(queue);
  }

  function initAll() {
    document.querySelectorAll("[data-st-footer]").forEach(init);
  }

  initAll();
  // Theme editor: the section is re-rendered on every setting change.
  document.addEventListener("shopify:section:load", initAll);
})();
